// extracted by css-extract-rspack-plugin
export default {"wrapper":"_THLQ","textareaRoot":"Cq7G0","textareaWrapper":"Uu_pJ","textareaInput":"S82pX"};